import {
  TaxTraxTaxBillsState,
  TaxTraxTaxBillsActionTypes,
  TAXTRAX_TAX_BILLS_ADD,
  TAXTRAX_TAX_BILLS_CLEAR,
  TAXTRAX_TAX_BILLS_LOADING,
} from './TaxTraxTaxBills.types';

const defaultState: TaxTraxTaxBillsState = {
  response: null,
  property: null,
  loading: false,
};

export function taxTraxTaxBillsReducer(
  state = defaultState,
  action: TaxTraxTaxBillsActionTypes,
): TaxTraxTaxBillsState {
  switch (action.type) {
    case TAXTRAX_TAX_BILLS_CLEAR: {
      return {
        ...defaultState,
      };
    }
    case TAXTRAX_TAX_BILLS_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case TAXTRAX_TAX_BILLS_ADD: {
      return {
        ...state,
        response: action.payload.response,
        property: action.payload.property,
      };
    }
    default:
      return state;
  }
}
